export default __webpack_public_path__ + "static/media/DSC_7444.1e1472fd.jpg";